import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { MatDialog } from '@angular/material';
import { Observable } from 'rxjs';
import { AppLoaderComponent } from './app-loader.component';

@Injectable()
export class AppLoaderService {
  dialogRef: MatDialogRef<AppLoaderComponent>;
  message:string=''
  constructor(private dialog: MatDialog) { }

  public open(title: string = 'Patientez \n ...',message:string=''): Observable<boolean> {
    this.dialogRef = this.dialog.open(AppLoaderComponent, { disableClose: true, backdropClass: 'light-backdrop'});
    this.dialogRef.updateSize('300px');
    this.dialogRef.updatePosition({top:'200px'})
    this.dialogRef.componentInstance.title = title 
    this.dialogRef.componentInstance.message = message
    return this.dialogRef.afterClosed();
  }

  public close() {
    if(this.dialogRef)
      this.dialogRef.close();
  }
}
